/////////////////////////////////////////////////V5CommentStart
// 2021-03-13 - converted to select statement
// 2021-03-16 - Big Cleanup
/////////////////////////////////////////////////V5CommentEnd

import React from 'react'
import {
  Row,
  Col,
  Form,
  FormGroup,
  InputGroup,
  ControlLabel,
  FormControl,
  HelpBlock,
  Button,
} from 'react-bootstrap'
import FontAwesome from 'react-fontawesome'
import queryString from 'query-string'

import { getLocation } from '../utils/location'
import { getLiteLocationFromIP } from '../utils/location'

import './SearchAreaForm.css'

//---------------------------------------
// class
//---------------------------------------
export default class SearchAreaForm extends React.PureComponent {
  //---------------------------------------
  // Constructor
  //---------------------------------------
  constructor(props) {
    console.log(`CFD_FUNC_SAF_constructor:`)
    super(props)
    let { radius, zipCode = '' } = {
      ...this.props.search,
      ...this.props.app.myLocationInfo,
    }
    try {
      radius = parseInt(radius, 10)
      if (isNaN(radius)) throw Error('NaN')
    } catch (err) {
      radius = 25000
    }
    // not sure why we nationwide as a separate state
    this.state = {
      //nationwide: radius >= 25000,
      radius: radius >= 25001 ? 100 : `${radius}`,
      zipCode,
      error: '',
      updated: false,
    }
    this.buttonTitle = this.state.zipCode
      ? 'Change Search Area'
      : 'Select Search Area'
    this.hasGeolocation = false // ('geolocation' in navigator)
    this.id = `SearchAreaForm-${this.props.id}`
  } // end constructor

  //---------------------------------------
  //
  //---------------------------------------
  handleChange = event => {
    console.log(`CFD_FUNC_SAF_handleChange:`)
    event.preventDefault()
    const { name, value } = event.target
    if (name === 'zipCode') {
      if (value.match(/^\d{0,5}$/)) {
        this.setState({
          zipCode: value,
          updated: true,
        })
      }
    } else {
      this.setState({
        [name]: value,
        updated: true,
      })
    }
  } // end handleChange

  //---------------------------------------
  //
  //---------------------------------------
  handleChangeRadius = radius => {
    console.log(`CFD_FUNC_SAF_handleChangeRadius:`)
    this.setState({ radius, updated: true })
  }

  //---------------------------------------
  //
  //---------------------------------------
  handleSubmit = event => {
    console.log(`CFD_FUNC_SAF_handleSubmit: check this out sumtime`)

    event.preventDefault()
    if (!this.state.updated) return

    let error = null
    const { zipCode, radius } = {
      ...this.state,
    }
    if (!zipCode.match(/^\d{5}$/)) {
      error = new Error('Zip code must be 5 digits')
    } else if (zipCode.match(/^000/)) {
      error = new Error('Invalid zip code')
    }

    console.log(`CFD_FUNC_SAF_handleSubmit2:` + zipCode + '||' + radius)
    this.setState({ error })
    if (error) return

    return getLiteLocationFromIP(zipCode)
      .then(result => {
        {
          const {
            address,
            latitude,
            longitude,
            city,
            state,
            zipCode,
            countryCode,
          } = result
        }

        const search = { ...this.props.search, radius, zipCode }
        search.page = 1
        console.log(`CFD JJJ: SAF: pushing search `)
        this.props.history.push({
          ...this.props.location,
          search: '?' + queryString.stringify(search),
        })

        if (this.props.onSubmit) {
          console.log(`CFD JJJ: SAF: submitting search 22222` + search)
          this.props.onSubmit(search)
        }
      })
      .catch(err => {
        //console.log('MILLERLITE ERROR CAUGHT  ' + err.message)
        error = new Error(
          'Invalid zip code detected. Please try a different one'
        )
        this.setState({ error })
        return
      })
  } //handleSumbit

  //---------------------------------------
  //
  //---------------------------------------
  handleClick = () => {
    console.log(`CFD_FUNC_SAF_handleClick:`)
    getLocation()
      .then(location => {
        this.setState({
          address: location.address,
          zipCode: location.address.zipCode,
          error: '',
        })
        return location
      })
      .catch(error => {
        this.setState({
          Error: 'Geolocation is unavailable. Please enter a zip code.',
        })
        this.hasGeolocation = false
      })
  } //handleClick

  //---------------------------------------
  //
  //---------------------------------------
  render() {
    console.log(`CFD_FUNC_SAF_render:`)
    const geolocation = this.hasGeolocation ? (
      <InputGroup.Button>
        <Button
          className="geolocation-button"
          onClick={this.handleClick}
          title="Use your device location"
        >
          <FontAwesome name="compass" size="2x" />
        </Button>
      </InputGroup.Button>
    ) : null

    const validLocation = !!this.state.zipCode.match(/^\d{5}$/)

    return (
      <Form className="SearchAreaForm" onSubmit={this.handleSubmit}>
        <Row>
          <Col xs={12}>
            {this.state.error && (
              <p class="error">{this.state.error.message}</p> // this is where the Zip error is
            )}
          </Col>
          <Col xs={12}>
            <FormGroup
              controlId={`${this.id}-zip-code-input`}
              validationState={this.state.error ? 'error' : null}
            >
              <InputGroup>
                {geolocation}
                <ControlLabel>ZipCode</ControlLabel>
                <FormControl
                  className="zip-code-input"
                  name="zipCode"
                  placeholder="Enter zip code"
                  autoComplete="postal-code"
                  minLength={5}
                  maxLength={5}
                  min={1}
                  value={this.state.zipCode || ''}
                  onChange={this.handleChange}
                />
              </InputGroup>
              <HelpBlock>
                {this.state.zipCode ? 'Change Zip Code' : 'Enter Zip Code'}
                {geolocation
                  ? ' or click the geolocation button to use your current location'
                  : ''}
              </HelpBlock>
            </FormGroup>
          </Col>

          <Col xs={12}>
            <FormGroup controlId={`${this.id}-radius-input`}>
              <ControlLabel>Search Radius</ControlLabel>
              <FormControl
                title="Select Search Radius"
                value={this.state.radius || ''}
                componentClass="select"
                name="radius"
                placeholder="radius"
                onChange={this.handleChange}
              >
                <option value="15" key="15">
                  15 miles{' '}
                </option>
                <option value="30" key="30">
                  30 miles{' '}
                </option>
                <option value="45" key="45">
                  {' '}
                  45 miles{' '}
                </option>
                <option value="60" key="60">
                  {' '}
                  60 miles{' '}
                </option>
                <option value="90" key="90">
                  {' '}
                  90 miles{' '}
                </option>
                <option value="120" key="120">
                  120 miles{' '}
                </option>
                <option value="180" key="180">
                  180 miles{' '}
                </option>
                <option value="240" key="240">
                  240 miles{' '}
                </option>
                <option value="360" key="360">
                  360 miles{' '}
                </option>
                <option value="500" key="500">
                  500 miles{' '}
                </option>
                <option value="1000" key="1000">
                  1000 miles{' '}
                </option>
                <option value="25000" key="25000">
                  Nationwide
                </option>
              </FormControl>
              <HelpBlock>
                {validLocation
                  ? 'Select approximate search area'
                  : 'Zip code required'}
              </HelpBlock>

              <FormControl.Feedback />
            </FormGroup>
          </Col>

          <Col xs={12}>
            <Button
              type="submit"
              className="submit"
              disabled={!this.state.updated}
            >
              {this.buttonTitle}
            </Button>
          </Col>
        </Row>
      </Form>
    )
  } //end Render
} // end Class



// WEBPACK FOOTER //
// ./src/components/SearchAreaForm.js